<template>
  <div class="page-content">
    <page-template
      ref="goodsComprehensive"
      class="info-container"
      :tableOptions="tableOptions"
      :searchOptions="searchOptions"
      :toolConfig="toolConfig"
      @searchReset="searchReset"
    ></page-template>
    <!--    多规格详情-->
    <el-dialog title="规格详情"
               :visible.sync="specsDetailShow"
               width="1000px"
               height="2000px"
               :close-on-click-modal="false"
    >
      <more-table
        v-if="specsDetailShow"
        ref="specsDetailColumns"
        :tableColumns="specsDetailColumns"
        :data="specsDetailData"
      >
      </more-table>
    </el-dialog>
  </div>
</template>

<script>
  import pageTemplate from '@/components/template/pageTemplate';
  import api from '@/config/api';
  import userPower from '@/mixin/userPower';
  import moreTable from "@/components/business/moreTable";

  export default {
    mixins: [userPower],
    components: {
      pageTemplate, moreTable

    },
    data() {
      return {
        specsDetailShow: false,
        specsDetailData: [],
        specsDetailColumns: [
          {
            label: "规格名称",
            prop: "specsNameList",
            width: "100",
            align: "center",
          },
          // {
          //   prop: "specsImageUrl",
          //   label: "规格图片",
          //   align: "center",
          //   type: "image",
          //   width: "100",
          // },
          {
            label: "规格条码",
            prop: "specsBarCode",
            align: "center",
            width: "150",
          },
          {
            prop: "buyPrice",
            label: "进价",
            align: "center",
            width: "100",
          },
          {
            prop: "retailPrice",
            label: "零售价",
            align: "center",
            width: "100",
          },
          {
            prop: "vipPrice",
            label: "会员价",
            align: "center",
            width: "100",
          },
          {
            prop: "mallRetailPrice",
            label: "商城零售价",
            align: "center",
            width: "100",
          },
          {
            prop: "mallVipPrice",
            label: "商城会员价",
            align: "center",
            width: "100",
          },
          {
            prop: "mallPlusVipPrice",
            label: "商城Plus会员价",
            align: "center",
            width: "150",
          },
        ],
        labelWidth: "150",
        dialogVisibility: false,
        // 按钮
        toolConfig: [],
        // 高级搜索条件
        searchOptions: {
          labelWidth: '70px',
          simple: [
            {label: '商品名称', prop: 'name', type: 'input', isFuzzy: true, placeholder: "请输入商品名称"},

          ],
          complex: [
            {label: '商品条码', prop: 'barCode', type: 'input', isFuzzy: true, placeholder: "请输入商品条码", span: 6,},
            {
              label: "门店名称",
              type: "select",
              prop: "storeId",
              span: 6,
              data: [],
              isHasAll: true,
              defaultValue: -1,
              change: this.getBrandSupplierChange,
              url: api.system.seStore
            },
            {
              label: "品牌",
              type: "select",
              prop: "goodsBrandId",
              span: 6,
              data: [],
              //url: api.archives.brand
            },
            {
              label: "供应商",
              type: "select",
              prop: "supplierId",
              span: 6,
              data: [],
              //url: api.archives.supplier
            },
            // {
            //   label: "商品类型",
            //   type: "select",
            //   prop: "type",
            //   span: 6,
            //   data: this.$utils.getCacheStatus("asGoods.type")
            // },
            {
              label: "商品类别",
              type: 'cascaderMultiple',
              prop: 'goodsCategoryIds',
              data: [],
              span: 6,
              valueKey: 'value',
              change: this.typeChange,
              url: api.archives.getCategoryTree,
            },
            {
              label: "计价方式",
              type: "select",
              prop: "pricingMethod",
              span: 6,
              data: this.$utils.getCacheStatus("asGoods.pricingMethod")
            },
            {label: '进货价', prop: 'BuyPrice', type: 'numberRange', span: 6, inputWidth: '90px'},
            {label: '零售价', prop: 'RetailPrice', type: 'numberRange', span: 6, inputWidth: '90px'},
          ]
        },
        // 表格信息配置
        tableOptions: {
          indexShow: true,//是否显示索引
          columns: [
            {label: '条码', prop: 'barCode', width: '120', align: 'center'},
            {label: '自编码', prop: 'artNo', width: '120', align: 'center'},
            {label: '商品名称', prop: 'name', width: '120', align: 'center'},
            {
              label: '规格',
              prop: 'buyPrice',
              width: '70',
              align: 'center',
              deal: this.specsDetail,
              callback: this.specsClick,
            },
            {label: '单位', prop: 'unitName', width: '70', align: 'center'},
            {label: '供应商', prop: 'supplierName', width: '120', align: 'center'},
            {label: '进货价', prop: 'buyPrice', width: '100', align: 'center'},
            {label: '零售价', prop: 'retailPrice', width: '100', align: 'center'},
            {label: '毛利率', prop: 'retailPrice', width: '100', align: 'center', deal: this.maoLv},
            {label: '会员价', prop: 'vipPrice', width: '100', align: 'center'},
            {label: '批发价', prop: 'tradePrice', width: '100', align: 'center'},
            {label: '最低售价', prop: 'lowestPrice', width: '100', align: 'center'},
            // {
            //   label: '商品类型',
            //   prop: 'type',
            //   width: '120',
            //   align: 'center',
            //   enumData: this.$utils.getCacheStatus("asGoods.type")
            // },
            {label: '商品类别', prop: 'goodsCategoryName', width: '120', align: 'center'},
            {
              label: '计价方式',
              prop: 'pricingMethod',
              width: '125',
              align: 'center',
              enumData: this.$utils.getCacheStatus("asGoods.pricingMethod")
            },
            {label: '品牌', prop: 'goodsBrandName', width: '120', align: 'center'},
            {
              label: '来源',
              prop: 'addType',
              width: '70',
              align: 'center',
              enumData: this.$utils.getCacheStatus("asGoods.addType")
            },
            {
              label: "产地",
              prop: "placeOrigin",
              width: "160",
              align: "center",
            },
            {
              label: "等级",
              prop: "goodsLevel",
              width: "160",
              align: "center",
            },
            {
              label: "采购周期",
              prop: "purchaseCycle",
              width: "160",
              align: "center",
            },
            {
              label: "商品状态",
              prop: "status",
              width: "160",
              align: "center",
              enumData: this.$utils.getCacheStatus('asGoods.status')
            },
            {
              label: "提成方式",
              prop: "guiderCommissionType",
              width: "160",
              align: "center",
              enumData: this.$utils.getCacheStatus("asGoods.guiderCommissionType")
            },
            {
              label: "提成金额",
              prop: "commissionMoney",
              width: "160",
              align: "center",
            },
            {
              label: "提成率",
              prop: "commissionPercentage",
              width: "160",
              align: "center",
            },
            {
              label: "保质期",
              prop: "qualityGuaranteePeriod",
              width: "160",
              align: "center",
            },
            {
              label: "厂家指导价",
              prop: "guidePrice",
              width: "160",
              align: "center",
            },
            {
              label: "管理库存",
              prop: "openInventory",
              width: "160",
              align: "center",
              selfData: true,
            },
            {
              label: "允许议价",
              prop: "bargaining",
              width: "160",
              align: "center",
              selfData: true,
            },
            {
              label: "允许赠送",
              prop: "give",
              width: "160",
              align: "center",
              selfData: true,
            },
            {
              label: "允许折扣",
              prop: "offlineDiscount",
              width: "160",
              align: "center",
              selfData: true,
            },
            {
              label: "创建时间",
              prop: "createDttm",
              width: "160",
              align: "center",
            },
          ],
          // url: api.archives.goodsInfo
        },
      };
    },
    created() {
      this.setStore(this.searchOptions.complex);
      let storeId = this.$utils.getSysUser().storeId;
      if (storeId) {
        this.getBrandSupplier();
      } else {
        this.getBrandSupplierChange({storeId: storeId})
      }
    },
    mounted() {
      if (Object.keys(this.$route.params).length > 0) {
        if (this.$route.params.customQuery) {
          let str = this.$route.params.customQuery
          this.tableOptions.param = eval('(' + str + ')')
        }
        if (this.$route.params.code == '3') {
          this.tableOptions.param = {maxBuyPrice: 0}
        }
      }
      this.$nextTick(() => {
        this.tableOptions.url = api.archives.goodsInfo
        this.$refs['goodsComprehensive'].operationSuccess();
      })
    },
    methods: {
      // 查看多规格详情
      specsDetail(row, column) {
        if (row.openSpecs) {
          return '<span class="td-click">多规格</span>'
        } else {
          if (row.specs) {
            return '<span>' + row.specs + '</span>'
          }
        }
      },
      // 点击多规格查看
      specsClick(row) {
        if (row.openSpecs) {
          this.specsDetailData = []
          this.specsDetailShow = true
          this.$loading({})
          this.$axios.fetchPost(api.baseInfo.getSpecsList, {goodsId: row.id}).then((data) => {
            if (data.code == 200) {
              if (data.data && data.data.specsList) {
                this.$nextTick(() => {
                  this.specsDetailData = data.data.specsList
                })
              }
            }
          }).finally(() => {
            this.$loading({}).close()
          })
        }
      },
      // 搜索重置
      searchReset() {
        if (!this.$utils.getSysUser().storeId) {
          this.searchOptions.complex.filter(item => item.prop === 'goodsBrandId')[0].data = []
          this.searchOptions.complex.filter(item => item.prop === 'supplierId')[0].data = []
        }
      },
      // 毛利率
      maoLv(row) {
        let value = 0
        if (row.retailPrice != 0) {
          value = ((row.retailPrice - row.buyPrice) / row.retailPrice).toFixed(4)
        } else {
          value = 0
        }
        return `<span>${(value * 100).toFixed(2)}%</span>`;
      },
      getBrandSupplier() {
        let userInfo = this.$utils.getSysUser();
        if (userInfo.storeId) {
          this.$axios.fetchPost(api.archives.brand + '/query/brand/list', {}).then(data => {
            if (data.code === 200) {
              this.searchOptions.complex.filter(item => item.prop === 'goodsBrandId')[0].data = data.data;
            }
          });
          this.$axios.fetchPost(api.archives.supplier + '/query/supplier/list', {}).then(data => {
            if (data.code === 200) {
              this.searchOptions.complex.filter(item => item.prop === 'supplierId')[0].data = data.data;
            }
          })
        }
      },
      getBrandSupplierChange(form) {
        form.goodsBrandId = '';
        form.supplierId = '';
        this.$axios.fetchPost(api.archives.brand + '/query/brand/list', {storeId: form.storeId}).then(data => {
          if (data.code === 200) {
            this.searchOptions.complex.filter(item => item.prop === 'goodsBrandId')[0].data = data.data;
          }
        });
        this.$axios.fetchPost(api.archives.supplier + '/query/supplier/list', {storeId: form.storeId}).then(data => {
          if (data.code === 200) {
            this.searchOptions.complex.filter(item => item.prop === 'supplierId')[0].data = data.data;
          }
        })
      }
    }
  };
</script>

<style scoped>
  .info-container {
    padding-top: 0;
  }
</style>



// WEBPACK FOOTER //
// src/page/archives/query/Info.vue